import { getApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";

import { REGION } from "store/ref";

const app = getApp();
const functions = getFunctions(app, REGION);

// get functions api.
export const getApiFunctions = () => {
  //:::::::::::: QC BAILIFF ::::::::::::: //
  const passQC = httpsCallable(
    functions,
    "api-draft-dialog-operator-pass-dialog",
  ); // {id}
  const warnQC = httpsCallable(
    functions,
    "api-draft-dialog-operator-warn-dialog",
  ); // {id, reason}
  const denyQC = httpsCallable(
    functions,
    "api-draft-dialog-operator-deny-dialog",
  ); // {id, reason}
  const fixSentences = httpsCallable(
    functions,
    "api-draft-dialog-operator-fix-sentence",
  ); // { id, slot, text, start, end, speaker }

  const addInsert = httpsCallable(
    functions,
    "api-draft-dialog-operator-insert-create-sentence",
  ); // { id, slot, text, start, end, speaker };  điều kiện slot = x.xxx

  const removeInsert = httpsCallable(
    functions,
    "api-draft-dialog-operator-insert-remove-slot",
  ); // { id, slot }; xoá slot insert

  const updateInsert = httpsCallable(
    functions,
    "api-draft-dialog-operator-insert-update-sentence",
  ); // { id, slot, text, start, end, speaker }

  const addDelete = httpsCallable(
    functions,
    "api-draft-dialog-operator-delete-create-slot",
  ); // { id, slot }

  const removeDelete = httpsCallable(
    functions,
    "api-draft-dialog-operator-delete-remove-slot",
  ); //

  const fordWardDialog = httpsCallable(
    functions,
    "api-draft-bailiff-forwarding-client",
  ); // { id, numberOfPage }

  //:::::::::::: VERIFY KYC ::::::::::::: //
  const verifyKyc = httpsCallable(functions, "api-operator-paper-approve-kyc"); // {client}
  const denyKyc = httpsCallable(functions, "api-operator-paper-deny-kyc"); // {client, reason}

  //:::::::::::: CRUD COMPUTER MACHINE ::::::::::::: //
  const addMachine = httpsCallable(functions, "operator-computer-add-machine"); // {{worker}}
  const updateStatusMachine = httpsCallable(
    functions,
    "operator-computer-update-status",
  ); // {id}
  const deleteMachine = httpsCallable(
    functions,
    "operator-computer-delete-machine",
  ); // {id}
  const forceCloseMachine = httpsCallable(
    functions,
    "operator-computer-force-close",
  ); // {id}

  //:::::::::::: OPERATOR DEBUG JOB ::::::::::::: //
  // debug job. -> dành cho operator.
  const debugJob = httpsCallable(functions, "api-operator-job-debug-add"); // {id}

  // return.
  return {
    operator: {
      fordWardDialog,
      // update text
      fixSentences,
      addInsert,
      removeInsert,
      updateInsert,
      addDelete,
      removeDelete,
      // qc
      passQC,
      denyQC,
      warnQC,
      // virtual machine
      addMachine,
      updateStatusMachine,
      deleteMachine,
      forceCloseMachine,

      //debug
      debugJob,
    },
    kyc: {
      verifyKyc,
      denyKyc,
    },
  };
};
